


















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CampaignListModule } from '@/store/modules/campaignList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';
import CampaignStatus from '@/components/Campaigns/Display/CampaignStatus.vue'

@Component({
    name: 'CampaignListSearchCriteria',
    components: { CampaignStatus }

})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.agencyUsers) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
    }
  }

  @Watch('searchOptions.selectedBranch') 
  async onBranchChanged(val: BranchDto, oldVal: BranchDto){
    if (!val) {
      this.searchOptions.selectedDesk = null;
    }
  }

  get desks() {
    if (this.searchOptions.selectedBranch) {
        return this.searchOptions.selectedBranch.desks;
    }
    return [];
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get searchOptions() {
      return CampaignListModule.filterCampaignSearchViewModel;
  }

  get currentSearchCriteria() {
      return CampaignListModule.currentCampaignSearchCriteria;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get statusOptions() {
    return ListUtils.campaignStatuses();
  }

  get loading() {
    return CampaignListModule.loading;
  }

  async search() {
    this.dialog = false;
    await CampaignListModule.searchCampaigns()
  }
}
